import { useContext } from 'react';
import { Box } from 'styled-system/jsx';

import { ExchangeContext } from './Context';

export const MarketPrice = () => {
  const { inputToken, outputToken, marketPrice } = useContext(ExchangeContext);

  if (!inputToken || !outputToken) return null;

  return (
    <Box>
      1 {inputToken.displaySymbol || inputToken.symbol} ≈ {marketPrice ? parseFloat(marketPrice).toFixed(4) : '...'} {outputToken.displaySymbol || outputToken.symbol}
    </Box>
  );
};

